export default __webpack_public_path__ + "static/media/mail.ad625456.svg";